import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import RankedG2WithTextBlock from 'src/app/molecules/RankedG2WithTextBlock/RankedG2WithTextBlock';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';

const RankedG2 = (): JSX.Element => {
  return (
    <RankedG2WithTextBlock
      heading={{
        text: 'Ranked #1 by G2',
        type: 'heading',
        size: 'xl',
        fontWeight: 'font-weight-semibold',
      }}
      supportingText={{
        type: 'paragraph',
        as: 'span',
        size: 'xl',
        fontWeight: 'font-weight-regular',
        textAlign: 'left',
        children: (
          <Stack
            direction='column'
            gap='spacing-lg'
            as='span'
          >
            <Typography
              type='paragraph'
              size='xl'
            >
              With a satisfaction score of 100/100 and over 500 positive reviews.
            </Typography>
            <Typography
              type='paragraph'
              size='xl'
            >
              *We know, people <i>love</i> to say this. When we say it?
            </Typography>
          </Stack>
        ),
      }}
      additionalContent={
        <Button
          variant='brand-text-link'
          size='xl'
          href='https://www.g2.com/categories/online-community-management?tab=highest_rated'
        >
          It’s true. 😎
        </Button>
      }
    />
  );
};

export default RankedG2;
